import { render, staticRenderFns } from "./SideFixedMenu.vue?vue&type=template&id=4f481c2b&scoped=true&"
import script from "./SideFixedMenu.vue?vue&type=script&lang=js&"
export * from "./SideFixedMenu.vue?vue&type=script&lang=js&"
import style0 from "./SideFixedMenu.vue?vue&type=style&index=0&id=4f481c2b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f481c2b",
  null
  
)

export default component.exports